import type { ReactNode } from "react";

interface Props {
  open: boolean;
  onClose?: () => void;
  children: ReactNode;
  labelledBy?: string;
}

export function GameModal({ open, onClose, children, labelledBy }: Props) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm"
      role="presentation"
      onClick={onClose}
    >
      <div
        className="cw-panel p-6 reveal-pop text-center max-w-md w-full space-y-4 shadow-2xl shadow-violet-900/40 max-h-[min(92vh,100dvh)] overflow-y-auto"
        role="dialog"
        aria-modal="true"
        aria-labelledby={labelledBy}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}
